import { TeamTurns } from "./Game";
import { Difficulty, SubcategoryNumberOfQuestionsModel } from "./Question";
import { Player } from "./User";

export interface CategoryEntity {
  _id?: string;
  title?: string;
  imageFile?: File;
  imageUrl?: string;
  hidden?: boolean;
  locked?: boolean;
  subcategories?: Array<string>;
}

export interface Category {
  id: string;
  title: string;
  imageUrl: string;
  isSelected: boolean;
  locked: boolean;
  subcategories: Array<Subcategory>;
  pointsHashmap: Map<TeamTurns, Map<Difficulty, boolean>>;
  numberOfQuestionsForEachSubcategory?: Array<SubcategoryNumberOfQuestionsModel>;
}

export interface Subcategory {
  title: string;
  isSelected: boolean;
}

export interface UnlockCategoryRequestModel {
  code: string
  categoryId: string
}

export interface CategoryUnlockCode {
  _id?: string;
  code?: string;
  category?: CategoryEntity;
  usedBy?:  Player;
  createdAt?: Date;
}

export function convertCategoryEntityToCategory(
  categoryEntity: CategoryEntity
): Category {
  const subcategories: Array<Subcategory> = [];
  categoryEntity.subcategories?.map((s) =>
    subcategories.push({ title: s, isSelected: false })
  );

  const pointsHashmap: Map<TeamTurns, Map<Difficulty, boolean>> = new Map([
    [
      TeamTurns.teamA,
      new Map([
        [Difficulty.EASY, false],
        [Difficulty.MEDIUM, false],
        [Difficulty.HARD, false],
      ]),
    ],
    [
      TeamTurns.teamB,
      new Map([
        [Difficulty.EASY, false],
        [Difficulty.MEDIUM, false],
        [Difficulty.HARD, false],
      ]),
    ],
  ]);
  return {
    id: categoryEntity._id!,
    title: categoryEntity.title!,
    imageUrl: categoryEntity.imageUrl!,
    isSelected: false,
    locked: categoryEntity.locked ? categoryEntity.locked : false,
    subcategories: subcategories,
    pointsHashmap: pointsHashmap,
  };
}

export function convertCategoryEntityListToCategoryList(
  categoryEntities: Array<CategoryEntity>
): Array<Category> {
  const categories: Array<Category> = [];

  categoryEntities.map((categoryEntity, i) => {
    categories.push(convertCategoryEntityToCategory(categoryEntity));
  });
  return categories;
}

export const sampleCategories: Array<CategoryEntity> = [
  {
    _id: "1",
    title: "Car",
    imageUrl:
      "https://www.trivianerd.com/assets/topics/banners/cars-general.jpg",
    subcategories: [
      "difficulty",
      "never",
      "furniture",
      "thus",
      "transportation",
      "opportunity",
      "beautiful",
      "exactly",
      "standard",
      "kept",
      "baseball",
      "perfectly",
      "term",
      "egg",
      "must",
      "fix",
    ],
  },
  {
    _id: "2",
    title: "Christmas",
    imageUrl:
      "https://www.trivianerd.com/assets/topics/banners/ann-danilina-c_rnpbsyvfm-unsplash-(1).jpg",
    subcategories: ["difficulty", "never", "furniture", "egg", "must", "fix"],
  },
  {
    _id: "3",
    title: "Europe",
    imageUrl: "https://www.trivianerd.com/assets/topics/banners/europe.jpg",
    subcategories: [
      "difficulty",
      "kept",
      "baseball",
      "perfectly",
      "term",
      "egg",
      "must",
      "fix",
    ],
  },
  {
    _id: "4",
    title: "Geology",
    imageUrl: "https://www.trivianerd.com/assets/topics/banners/geology.jpg",
    subcategories: [
      "difficulty",
      "never",
      "furniture",
      "thus",
      "transportation",
      "opportunity",
      "beautiful",
      "exactly",
      "standard",
      "kept",
    ],
  },
  {
    _id: "5",
    title: "Movies",
    imageUrl:
      "https://www.trivianerd.com/assets/topics/banners/movie-quotes.jpg",
    subcategories: [
      "difficulty",
      "never",
      "furniture",
      "thus",
      "transportation",
      "opportunity",
      "beautiful",
      "exactly",
      "standard",
      "kept",
      "baseball",
      "perfectly",
      "term",
      "egg",
      "must",
      "fix",
    ],
  },
  {
    _id: "6",
    title: "Football",
    imageUrl:
      "https://www.trivianerd.com/assets/topics/banners/premier-league.jpg",
    subcategories: [
      "difficulty",
      "never",
      "furniture",
      "thus",
      "transportation",
      "opportunity",
      "beautiful",
      "exactly",
      "standard",
      "kept",
      "baseball",
      "perfectly",
      "term",
      "egg",
      "must",
      "fix",
    ],
  },
  {
    _id: "7",
    title: "Planes",
    imageUrl:
      "https://www.trivianerd.com/assets/topics/banners/top-gun-trivia-banner.jpg",
    subcategories: [
      "difficulty",
      "never",
      "furniture",
      "thus",
      "transportation",
      "opportunity",
      "beautiful",
      "exactly",
      "standard",
      "kept",
      "baseball",
      "perfectly",
      "term",
      "egg",
      "must",
      "fix",
    ],
  },
  {
    _id: "8",
    title: "War",
    imageUrl: "https://www.trivianerd.com/assets/topics/banners/war.jpg",
    subcategories: [
      "difficulty",
      "baseball",
      "perfectly",
      "term",
      "egg",
      "must",
      "fix",
    ],
  },
  {
    _id: "9",
    title: "WWE",
    imageUrl: "https://www.trivianerd.com/assets/topics/banners/wwe.jpg",
    subcategories: ["must", "fix"],
  },
  {
    _id: "10",
    title: "Youtube",
    imageUrl: "https://www.trivianerd.com/assets/topics/banners/youtube.jpg",
    subcategories: ["difficulty"],
  },
  {
    _id: "11",
    title: "Pixar",
    imageUrl:
      "https://www.trivianerd.com/assets/topics/banners/disney-pixar.jpg",
    subcategories: [],
  },
];
